import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { capitalize, startCase } from 'lodash';

@Directive({
  selector: '[controlValueToSentenceCase]',
  standalone: false,
})
export class ControlValueToSentenceCaseDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input') onInputEvent(): void {
    const valueToTransform = this.el.nativeElement.value;

    this.control.control.setValue(capitalize(startCase(valueToTransform)), {
      emitEvent: false,
    });
  }
}
